const productsTire = [
  'prod_item_status',
  'prod_brand_name',
  'prod_name_th',
  'sale_price',
  'price_remark',
  'promotion_sale_price',
  'promotion_remark',
  'green_card_promotion_sale_price',
  'green_card_promotion_remark',
  'ev_card_promotion_sale_price',
  'ev_card_promotion_remark',
  'is_highlight',
  'special_flag',
  'prod_desc_en',
  'prod_desc_th',
  'image',
  'thumbnail',
  'detail_image',
  'video_url',
  'warranty_image',
  'tire_speed_rating',
  'tire_load_index',
  'tire_treadwear',
  'tire_traction',
  'tire_temperature',
  'tire_characters',
  'slug_th',
  'slug_en',
]

const productsShock = [
  'prod_item_status',
  'prod_brand_name',
  'prod_name_th',
  'sale_price',
  'price_remark',
  'promotion_sale_price',
  'promotion_remark',
  'green_card_promotion_sale_price',
  'green_card_promotion_remark',
  'ev_card_promotion_sale_price',
  'ev_card_promotion_remark',
  'is_highlight',
  'special_flag',
  'prod_desc_en',
  'prod_desc_th',
  'image',
  'thumbnail',
  'detail_image',
  'video_url',
  'warranty_image',
  'shock_construction',
  'shock_car_type',
  'shock_type',
  'slug_th',
  'slug_en',
]

const productsOther = [
  'prod_item_status',
  'prod_brand_name',
  'prod_name_th',
  'sale_price',
  'price_remark',
  'promotion_sale_price',
  'promotion_remark',
  'green_card_promotion_sale_price',
  'green_card_promotion_remark',
  'ev_card_promotion_sale_price',
  'ev_card_promotion_remark',
  'is_highlight',
  'special_flag',
  'prod_desc_en',
  'prod_desc_th',
  'image',
  'thumbnail',
  'detail_image',
  'video_url',
  'warranty_image',
  'slug_th',
  'slug_en',
]

const productsLubricant = [
  'prod_item_status',
  'prod_brand_name',
  'prod_name_th',
  'sale_price',
  'price_remark',
  'promotion_sale_price',
  'promotion_remark',
  'green_card_promotion_sale_price',
  'green_card_promotion_remark',
  'ev_card_promotion_sale_price',
  'ev_card_promotion_remark',
  'is_highlight',
  'special_flag',
  'prod_desc_en',
  'prod_desc_th',
  'image',
  'thumbnail',
  'detail_image',
  'video_url',
  'warranty_image',
  'oil_viscosity_low_temp',
  'oil_viscosity_high_temp',
  'slug_th',
  'slug_en',
]

const productsBrake = [
  'prod_item_status',
  'prod_brand_name',
  'prod_name_th',
  'sale_price',
  'price_remark',
  'promotion_sale_price',
  'promotion_remark',
  'green_card_promotion_sale_price',
  'green_card_promotion_remark',
  'ev_card_promotion_sale_price',
  'ev_card_promotion_remark',
  'is_highlight',
  'special_flag',
  'prod_desc_en',
  'prod_desc_th',
  'image',
  'thumbnail',
  'detail_image',
  'video_url',
  'warranty_image',
  'slug_th',
  'slug_en',
]

const productsBattery = [
  'prod_item_status',
  'prod_brand_name',
  'prod_name_th',
  'sale_price',
  'price_remark',
  'promotion_sale_price',
  'promotion_remark',
  'green_card_promotion_sale_price',
  'green_card_promotion_remark',
  'ev_card_promotion_sale_price',
  'ev_card_promotion_remark',
  'is_highlight',
  'special_flag',
  'prod_desc_en',
  'prod_desc_th',
  'image',
  'thumbnail',
  'detail_image',
  'video_url',
  'warranty_image',
  'batt_amp',
  'batt_car_type',
  'slug_th',
  'slug_en',
]

export default {
  productsTire,
  productsShock,
  productsOther,
  productsLubricant,
  productsBrake,
  productsBattery,
}
